import initialState from './state.coffee'
import api from '@/api/api.coffee'
export default
  reset: (state) ->
    Object.keys(initialState).forEach (key, keyi) ->
      state[key] = initialState[key]
  updateStateTimeLastActive: (state, payload) ->
    state.stateTime.lastActive = payload
    state.stateTime.expiration.time = state.stateTime.lastActive + state.stateTime.expiration.ms
    state.stateTime.warning.time = state.stateTime.lastActive + (state.stateTime.expiration.ms - state.stateTime.warning.ms)
  # User
  updateUser: (state, user) ->
    state.user = Object.assign {}, user
  newUserPhone: (state, user) ->
    state.mobile = user
  # Restaurant / Location
  updateRestaurant: (state, restaurant) ->
    state.restaurant = Object.assign {}, state.restaurant, restaurant
  updateIpHeader: (state, header) ->
    state.ip =  header
  updateSubdomain: (state, subdomain) ->
    state.subdomain =  subdomain
  updateTableNo: (state, tableNo) ->
    state.tableNo = tableNo
  updateTakeoutLocations: (state, takeoutLocations) ->
    state.restaurant = Object.assign {}, state.restaurant, { takeoutLocations: takeoutLocations }
  updateDeliveryLocations: (state, deliveryLocations) ->
    state.restaurant = Object.assign {}, state.restaurant, { deliveryLocations: deliveryLocations }
  updateLocations: (state, locations) ->
    state.restaurant = Object.assign {}, state.restaurant, { locations: locations }
  updateClosedLocations: (state, locations) ->
    state.restaurant = Object.assign {}, state.restaurant, { closedLocations: locations }
  updateLocation: (state, location) ->
    state.location = location
  updateDescFlag: (state, flag) ->
    state.descFlag = flag
  updateMenuFlag: (state, flag) ->
    state.menuFlag = flag
  # Toggle
  updateToggleOpen: (state, toggleOpen) ->
    state.toggleOpen = toggleOpen
  updateToggleClose: (state, toggleClose) ->
    state.toggleClose = toggleClose
  # Order
  updateOrderHeader: (state, orderHeader) ->
    state.orderHeader = orderHeader
  updateOrderMessage: (state, orderMessage) ->
    state.orderMessage = orderMessage
  updateDiscount: (state, discount) ->
    state.discount = discount
  updateSubtotal: (state, subtotal) ->
    state.subtotal = subtotal
  updateOrder: (state, order) ->
    if !state.order
      state.order = {}
    if order
      state.order.items = []
      state.order.itemDetails = []
      state.order.editDetails = []
      state.order.discountItems = []
      state.order = Object.assign({}, state.order, order)
      if state.order.orderItems
        state.order.orderItemSum = []
        state.order.orderDetails = []
        ###
        state.order.orderSubTotal = 0.00
        state.order.orderTotal = 0.00
        ###
        state.order.orderItems.forEach (temp, tempi) ->
          state.order.items.push temp.uniqueId
          tempItemDetails = temp
          newMod = []
          temp.modifiers.forEach (mod, ind) ->
            if mod.side == ''
              newMod.push(mod)
          temp.modifiers.forEach (mod, ind) ->
            if mod.side && mod.side == 'Left'
              newMod.push(mod)
          temp.modifiers.forEach (mod, ind) ->
            if mod.side && mod.side == 'Whole'
              newMod.push(mod)
          temp.modifiers.forEach (mod, ind) ->
            if mod.side && mod.side == 'Right'
              newMod.push(mod)
          tempItemModifiers = newMod
          tempOrderAddons = temp.addons
          # Requires Edit Flag
          tempEdit = api.boolify(temp.requireEdit)
          if tempEdit == true
            state.order.editDetails = tempEdit
          tempOrderItemDetails = { itemDetails: tempItemDetails, itemModifiers: tempItemModifiers, itemAddons: tempOrderAddons, editFlag: tempEdit, itemSum: temp.itemTotal}
          # update the Details array
          state.order.itemDetails.push tempOrderItemDetails
          # update the Sums array (Total per orderItem)
          state.order.orderItemSum.push temp.itemTotal
        # Subtract the order coupon items amounts/percents
        state.order.orderDiscount = 0.00
        state.order.orderTaxAndFee = 0.00
        if state.order.discountItems
          state.order.discountItems.forEach (discountItem, discountItemIndex) ->
            if discountItem.type == "amount" || discountItem.type == "percent"
              if !Number.isNaN(parseFloat(discountItem.amount))
                state.order.orderDiscount = state.order.orderDiscount + parseFloat(discountItem.amount)
        # Calculate the orderTax
        if !Number(parseFloat(state.order.orderTaxAmount))
          state.order.orderTaxAmount = 0.00
        # Calculate the orderFee
        if !Number(parseFloat(state.order.orderFeeAmount))
          state.order.orderFeeAmount = 0.00
        # Calculate the orderTaxAndFee
        state.order.orderTaxAndFee = Number(state.order.orderTaxAmount) + Number(state.order.orderFeeAmount)
        # Calculate the deliveryFee
        if !Number(parseFloat(state.order.deliveryFee))
          state.order.deliveryFee = 0.00
        # Calculate the tip
        if !Number(parseFloat(state.order.tip))
          state.order.tip = 0.00
        # Calculate the orderTotal
        state.order.orderTaxes = state.order.orderTaxes
        state.order.orderFees = state.order.orderFees
        state.order.orderTotal =  parseFloat(state.order.orderTotal)
        state.order.orderDue = parseFloat(state.order.orderTotal)
      else
        state.order.orderSubTotal = 0.00
        state.order.tip = 0.00
        state.order.orderTotal = 0.00
        state.order.orderItemTotal = 0.00
        state.order.deliveryFee = 0.00
        state.order.orderDiscount = 0.00
  updateOrderDateTime: (state, orderdatetime) ->
    state.orderDateTime = orderdatetime
  updateOrderItem: (state, order) ->
    if state.order
      state.order.orderDetails = order
  updateOrderTip: (state, orderTip) ->
    if state.order
      state.order.tip = parseFloat(orderTip)
  updateOrderComment: (state, orderComment) ->
    if state.order
      state.order.comment = orderComment
  updateCustomerEmail: (state, customerEmail) ->
    if state.order
      state.order.email = customerEmail
  updateOrderUpdated: (state, updated) ->
    if state.order
      state.order.updated = updated
  updateOrderPlace: (state, placed) ->
    if state.order
      state.order.orderPlace = placed
  updateOrderStatus: (state, status) ->
    if state.order
     state.order.orderStatus = status
  updateTipLevels: (state, value) ->
    state.tipLevels = value
  # OrderMenu
  updateOrderMenu: (state, orderMenu) ->
    state.orderMenu = Object.assign {}, orderMenu
  updateOrderMenuDetails: (state, orderMenuDetails) ->
    state.orderMenuDetails = orderMenuDetails
  menuLoaded: (state, orderMenuDetails) ->
    state.orderMenuDetails = Object.assign [], orderMenuDetails
  # OrderItem
  addNewOrderItem: (state, orderItem) ->
    state.editor.orderItemNew = orderItem
  updateNewOrderItem: (state, orderItem) ->
    state.editor.orderItem = orderItem
  updateExistingOrderItem: (state, orderItem) ->
    state.editor.orderItem = orderItem
  # Coupons
  updateCoupons: (state, coupons) ->
    state.coupons.list = Object.assign {}, coupons
  updateCouponApply: (state, apply) ->
    state.restaurant.apply = Object.assign {}, apply
  updateCouponsMenu: (state, couponsMenu) ->
    state.coupons.menuCoupons = Object.assign {}, couponsMenu
  updateCouponItemIds: (state, coupons) ->
    state.coupons.itemIds = Object.assign({}, coupons)
  updateMywayIds: (state, myway) ->
    state.myway.itemIds = Object.assign({}, myway)
  updateEditorCoupon: (state, coupon) ->
    state.editor.coupon = coupon
  updateCouponsUpdated: (state, updated) ->
    state.coupons.updated = updated
  # Features
  updateFeatures: (state, features) ->
    state.features.list = Object.assign {}, features
  updateFeaturesUpdated: (state, updated) ->
    state.features.updated = updated
  # Recommendations
  updateRecommendations: (state, recommendations) ->
    state.recommendations.list = Object.assign {}, recommendations
  # Myway
  updateMyway: (state, myway) ->
    state.myway.list = Object.assign {}, myway
  updateMywayUpdated: (state, updated) ->
    state.myway.updated = updated
  # Drawers
  updatemenuDrawer: (state, menuDrawer) ->
    state.drawers.menu = menuDrawer
  updatecouponDrawer: (state, couponDrawer) ->
    state.drawers.coupon = couponDrawer
  updateorderDrawer: (state, orderDrawer) ->
    state.drawers.order = orderDrawer
  updatefeaturesDrawer: (state, featuresDrawer) ->
    state.drawers.features = featuresDrawer
  updatemywayDrawer: (state, mywayDrawer) ->
    state.drawers.myway = mywayDrawer
  # Dialog / Screen width
  updateDialogWidth: (state, dialogWidth) ->
    state.dialogWidth = dialogWidth
  updateScreenWidepx: (state, screenWidth) ->
    state.screenWidth = screenWidth
  # Language
  updateNativeLang: (state, lang) ->
    state.lang = lang
  # My Way
  updateHeaderMywayTitle: (state, headerMywayTitle) ->
    state.headerMywayTitle = headerMywayTitle
  # FAQs
  updateHeaderFaqTitle: (state, headerFaqTitle) ->
    state.headerFaqTitle = headerFaqTitle
  # Cart
  updateHeaderOrderTitle: (state, headerOrderTitle) ->
    state.headerOrderTitle = headerOrderTitle
  # Features
  updateHeaderFeaturesTitle: (state, headerFeaturesTitle) ->
    state.headerFeaturesTitle = headerFeaturesTitle
  updateForgetLabel: (state, forgetLabel) ->
    state.forgetLabel = forgetLabel
  # Coupons
  updateHeaderCouponTitle: (state, headerCouponTitle) ->
    state.headerCouponTitle = headerCouponTitle
  # Checkout
  updateHeaderCheckoutTitle: (state, headerCheckoutTitle) ->
    state.headerCheckoutTitle = headerCheckoutTitle
  # Buttons
  updateButtonMenuLabel: (state, buttonMenuLabel) ->
    state.buttonMenuLabel = buttonMenuLabel
  updateButtonCheckoutLabel: (state, buttonCheckoutLabel) ->
    state.buttonCheckoutLabel = buttonCheckoutLabel
  updateMenuDrawerRestartLabel: (state, menuDrawerRestartLabel) ->
    state.menuDrawerRestartLabel = menuDrawerRestartLabel
  updateFaqMessage: (state, faqMessage) ->
    state.faqMessage = faqMessage
  updateOkLabel: (state, okLabel) ->
    state.okLabel = okLabel
  # Pizza
  updatePizzaExtras: (state, pizzaExtras) ->
    state.pizzaExtras = pizzaExtras
  updateAddonExtras: (state, addonExtras) ->
    state.addonExtras = addonExtras
  updateItemTotal: (state, total) ->
    state.itemTotal = total
  updatePizzaCount: (state, pizzaCount) ->
    state.pizzaCount = pizzaCount
  # Panels
  updateCategoryPanels: (state, panels) ->
    state.panels.category = panels
  updatePizzaPanels: (state, panels) ->
    state.panels.pizza = panels
  updateTypePanels: (state, panels) ->
    state.panels.pizzaType = panels
  updateMenuItemGroupPanels: (state, panels) ->
    state.panels.menuitemgroup = panels
  # Misc
  updateMenuOverflowHidden: (state, value) ->
    state.menu.overflowHidden = value
  updateMenuItemDetails: (state, itemClickDetails) ->
    state.itemDetails = Object.assign {}, itemClickDetails
  updateModifierDetails: (state, modifierDetails) ->
    state.itemDetails.modifierDets = modifierDetails
  updateItemModselect: (state, itemDetails) ->
    state.order.orderItems = Object.assign {}, itemDetails
  updateTime: (state, locationtime) ->
    state.time = Object.assign {}, locationtime
  updateEditorOrderItem: (state, orderItem) ->
    state.editor.orderItem = orderItem
  updateItemId: (state, itemId) ->
    state.itemId = itemId
  updatePath: (state, path) ->
    state.path = path
  chooseCoupon: (state, payload) ->
    state.chooseCoupon = payload
  openCoupon: (state, payload) ->
    state.openCoupon = payload
  updateMap: (state, map) ->
    state.map = map
  updateError: (state, error) ->
    state.error = error
  updateErrorTitle: (state, errorTitle) ->
    state.errorTitle = errorTitle
  updateInformation: (state, information) ->
    state.information = information
  updateBaseURL: (state, baseURL) ->
    state.baseURL = baseURL
  orderAddPayment: (state, orderPayment) ->
    state.orderPayment = orderPayment
  clickFlag: (state, clickFlag) ->
    state.clickFlag = clickFlag
